<template>
  <div class="bgBlue">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <!-- <Banner :banner="bannerList"  @click="loseFocus()"></Banner> -->
    <div class="intro_box cont840">
	<div class="title_2">品牌顾问</div>
	<hr class="hr_1">
<dl>
	<dt>
		<img src="static/picture/advisor_1.jpg" /></dt>
	<dd>
		<h3>
			佐伯千津</h3>
		<p class="mt20">
			日本美容教母，被誉为&ldquo;神之手&rdquo;，在日本乃至世界美容界都享有盛名。出版书籍 50 余本，经常通过杂志、电视等媒体平台，以线下讲座、沙龙等方式向广大女性传达佐伯式美肌理论。</p>
		<p class="mt10">
			1967年，进入法国娇兰化妆品公司。</p>
		<p>
			1988年，进入法国 Parfums Christian Dior ，成为国际培训总监。</p>
		<p>
			1994年，掌管日本帝国酒店沙龙，被誉为拥有【神之手】。</p>
		<p>
			2003年，开办沙龙 Salon Do re Ma Beaute 。</p>
		<p>
			2004年，开设美容学校【佐伯式美肌塾】。</p>
		<p>
			2011年，《美肌茶房》创刊。</p>
		<h3 class="mt30">
			佐伯千津护肤核心理念</h3>
		<h2 class="mt20">
			一、拥抱衰老的事实</h2>
		<p>
			佐伯千津认为：&ldquo;随着年龄的增长，可以有皱纹，可以有斑点，可以松弛，这些都无可厚非。变老是自然法则，它意味着你活着，其他的一切都是谎言，你只需要自然地活着。&rdquo;</p>
		<h2 class="mt20">
			二、保持健康的心态</h2>
		<p>
			佐伯千津认为：&ldquo;脸部是心态健康的证明，你健康的显示器，你人生的招牌，当我看到一个人的脸时，我会知道关于他的一切。&rdquo;</p>
		<h2 class="mt20">
			三、提倡极简护肤</h2>
		<p>
			佐伯千津提倡尽可能利用自身身体来变美：&ldquo;从我们的手掌到手指，再到温暖的触摸及一点引发心跳加速的刺激，都可以为我们的肌肤提供养分。&rdquo;</p>
		<h2 class="mt20">
			四、护肤永远不会太迟</h2>
		<p>
			护肤无关于性别和年龄，不管男性、女性、任何年龄层，都有追求美和健康的权利。所以只要从今天，从当下开始，专注于美容护理，都不算太迟！</p>
		<p style=" margin: 40px auto;
    text-align: center;
    font-size: 40px;
    line-height: 40px;
    color: #2e2e2e;
    font-family: Font_Normal;    margin-left: 80px;">
			专业顾问团队</p>
		<p style="text-align: center;">
			Luara资深专业顾问包括日本美容界知名导师杉本千春，日本小颜整骨专家神野峪里香等，致力于为大家带来专业的护肤理念，帮助大家获得更好的护肤体验。</p>
	</dd>
</dl>
<hr class="hr_1 mt40" />
<dl>
	<dt style="text-align: justify;">
		<img src="static/picture/advisor_2.jpg" /></dt>
	<dd>
		<h3 style="text-align: justify;">
			杉本千春</h3>
		<p class="mt20" style="text-align: justify;">
			一般社团法人淋巴护理名单协会理事代表</p>
		<p style="text-align: justify;">
			淋巴倩碧艾利斯院长</p>
		<p style="text-align: justify;">
			ASUKA临床沙龙副院长</p>
		<p style="text-align: justify;">
			ASUKA临床学院主席讲师</p>
		<p style="text-align: justify;">
			基本理念「手掌里存在心灵之眼」</p>
		<p class="mt30 txt_in" style="text-align: justify;">
			毕业于圣德大学附属短期大学部国文秘书科,自小受到注重礼法的校风影响，非常深切体会礼仪的重要性，学得小笠原流礼法花鬚的「花鬚的正传」。毕业后，从事保险公司和医院的工作，因受理各项业务而忙坏了自己的身体，真实的感受到治疗和预防疾病的「淋巴护理」的必要性。重新到淋巴专业学校进修，并作为学校讲师开讲Lymph Clinique Alice。现成立了一般社团法人淋巴护理名单协会，经常出差为社员做淋巴护理，作为公司福利的一环，来管理社员的身体健康。</p>
		<p style="text-align: justify;">
			&middot; 作为化妆品生产商的淋巴主席讲师、到全国各地进行演讲</p>
		<p style="text-align: justify;">
			&middot; 曾参加御茶之水中央劳动信用金库女性支援企业80名的研讨会演讲</p>
		<p style="text-align: justify;">
			&middot; 受邀参与日本美博会（日本最大美容展览会）</p>
		<p style="text-align: justify;">
			&middot; 受邀参与医护人员主办的活动，在其中讲授淋巴护理的实用技巧<br />
			&middot; 曾为美容书籍的担任监督及指导工作，参与的书籍包括《耳穴的减肥疗法》 《减肥滚压器》《用岩盐泡澡的减肥方法》 《瘦脸头骨矫正》等书籍</p>
	</dd>
</dl>
<hr class="hr_1 mt40" />
<dl>
	<dt style="text-align: justify;">
		<img src="static/picture/advisor_3.jpg" /></dt>
	<dd>
		<h3 style="text-align: justify;">
			神野裕里香</h3>
		<p class="mt20 txt_in" style="text-align: justify;">
			高中毕业后，在名古屋一家以木笛为基础的小颜沙龙就职，连续两年成为顶级美容师。26岁独立在名古屋市内开设美容沙龙&ldquo;梦站&rdquo;。开业第一年，沙龙成为新顾客预约需等待2个月的人气沙龙。从业9年服务过1万人次以上的顾客。</p>
		<p style="text-align: justify;">
			在克鲁吉的故乡韩国，努力学习研究技术。她独特的技术是将面部表情肌拆解后再将淋巴液冲走，这一技术在印斯塔时代的年轻人中得到好评，好评如流。</p>
		<p style="text-align: justify;">
			不仅是美容技术，她在饮食、健康、审美、思考方式等方面的建议也得到了广大顾客的肯定，是日本社交网络时代十分活跃受欢迎的年轻美容师之一。</p>
		<p class="mt20" style="text-align: justify;">
			【美容理念】</p>
		<p style="text-align: justify;">
			重视&ldquo;发自内心的美丽&rdquo;的美容师。</p>
		<p style="text-align: justify;">
			座右铭是:喜欢自己，发掘自己的美。</p>
	</dd>
</dl>
<hr class="hr_1 mt40" />
<dl>
	<dt style="text-align: justify;">
		<img src="static/picture/advisor_4.jpg" /></dt>
	<dd>
		<h3 style="text-align: justify;">
			福山昌勝</h3>
		<p class="mt20 txt_in" style="text-align: justify;">
			福山昌勝毕业于日本庆英大学工学部化学科、美国北卡罗来纳州大学院。在日本佳丽宝公司任职24年，主要从事海外化妆品和健康产品的研发，佳丽宝的海外品牌『SENSAI』就是福山昌勝研发的。1987年就任于佳丽宝英国公司社长，使佳丽宝在英国化妆品牌中销售额达到了第八位。</p>
		<p class="txt_in" style="text-align: justify;">
			回国后受到LVMH集团邀请，1993年就任于日本GIVENCHY的顾问，加强了该品牌在日本的知名度，8年的时间内将品牌销售额提高了3倍，零售额为50亿日元，仅次于香奈儿，成为排于第二位的国际品牌。</p>
	</dd>
</dl>

</div>
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import Banner from '../../components/Banner.vue';
import RightNav from '../../components/RightNav.vue';
import { apiGetDetail, apiChangeOther, apiAddNotes } from '../../api/job.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    Banner: Banner,
    RightNav: RightNav
  },
  data() {
    return {
      advertInfo: { image: '../../static/pC/ad.png' },
      id:'',
      login: false, //是否登录
      userInfo: [] ,//是否登录--用户信息
      bannerList: [
        {url:'static/picture/luara_banner1.jpg'},
        {url:'static/picture/luara_banner2.jpg'},
        {url:'static/picture/luara_banner3.jpg'},
      ],
    };
  },
  created() {
    
  },
  methods: {
    
    //跳转到外部链接
    linkOut(url){
      if(url.includes('https://') || url.includes('http://') ){
      	window.location.href = url
      }else{
      	window.location.href = `https://${url}`
      }
    },
    
    //判断是否登录
    judgeLogin() {
      if (sessionStorage.getItem('login') != null && sessionStorage.getItem('login') != '') {
        this.login = sessionStorage.getItem('login');
        if (sessionStorage.getItem('userInfo') != null && sessionStorage.getItem('userInfo') != '') {
          var userInfo = sessionStorage.getItem('userInfo');
          this.userInfo = JSON.parse(userInfo);
        }
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 1110px){
    .cont840 {
        width: 840px;
        margin: 0 auto;
    }
}
@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}


@media (min-width: 1110px) {
	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------about_intro.html  start----------------*/
.intro_box{
	overflow: hidden;
	padding: 40px 0 60px;
}
.intro_box img{
	display: block;
	margin: 0 auto;
	max-width: 100%;
}
.intro_box h1{
	color: #2e2e2e;
	font-size: 18px;
	font-family: Font_Medium;
}
.intro_box p{
	color: #2e2e2e;
	line-height: 26px;
	margin: 0;
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl{
	width: 100%;
	overflow: hidden;
}
.intro_box dl dt{
	float: left;
	width: 245px;
}
.intro_box dl.dl_basic dt{
	width: 560px;
}
.intro_box dl.dl_100 dt{
	float: inherit;
	width: 100%;
}
.intro_box dl dt img{
	max-width: 100%;
}

.intro_box dl dd{
	float: right;
	width: calc(100% - 270px);
	color: #2e2e2e;
}
.intro_box dl.dl_basic dd{
	width: calc(100% - 580px);
}
.intro_box dl.dl_100 dd{
	float: inherit;
	width: 100%;
}
.intro_box dl dd h2{
	margin-top: 0;
	font-size: 15px;
	font-family: Font_Medium;
}
.intro_box dl dd p{
	font-size: 15px;
	font-family: Font_Light;
}
.intro_box dl dd h3{
	margin-top: 0;
	font-size: 18px;
	font-family: Font_Medium;
	overflow: hidden;
}
.intro_box dl dd span{
	display: inline-block;
	width: 400px;
	text-align: center;
	height: 54px;
	line-height: 50px;
	margin-right: 130px;
	color: #2e2e2e;
}
.intro_box dl dd i{
	letter-spacing: 1px;
	font-style: normal;
	font-size: 13px;
	font-family: Font_Medium;
}
.intro_box dl dd em{
	width: 32px;
	height: 30px;
	display: block;
    float: left;
	/* background: url(../images/addr.png) no-repeat 0px 0px; */
}
.intro_box dl dd a{
	float: right;
	color: #2e2e2e;
	font-size: 12px;
    font-family: Font_Medium;
	margin-top: 20px;
	padding-right: 15px;
	/* background: url(../images/more_jt.png) no-repeat right center; */
}
.intro_box dl dd a.a_link{
	float: inherit;
    font-family: Font_Medium;
	margin-top: 0;
	background: none;
}
/*------------about_intro.html  end----------------*/

</style>


// WEBPACK FOOTER //
// src/view/plus/CONSULTANT.vue